export default "__VITE_ASSET__Df3NVYkE__"